export default "__VITE_ASSET__b05984a3__"